import { useDocumentThemeMode, useTheme } from "../../hooks/theme.js";
import { isThemeMode } from "../../utils/theme.js";
import { Toaster } from "sonner";
import { jsx } from "react/jsx-runtime";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
// src/components/molecules/toaster.tsx
const Toaster$1 = (props) => {
	const { theme } = useTheme();
	const documentThemeMode = useDocumentThemeMode();
	const themeMode = isThemeMode(theme) ? theme : documentThemeMode;
	return /* @__PURE__ */ jsx(Toaster, {
		theme: themeMode,
		className: "toaster group",
		icons: {
			success: /* @__PURE__ */ jsx(CircleCheckIcon, { className: "size-4" }),
			info: /* @__PURE__ */ jsx(InfoIcon, { className: "size-4" }),
			warning: /* @__PURE__ */ jsx(TriangleAlertIcon, { className: "size-4" }),
			error: /* @__PURE__ */ jsx(OctagonXIcon, { className: "size-4" }),
			loading: /* @__PURE__ */ jsx(Loader2Icon, { className: "size-4 animate-spin" })
		},
		style: {
			"--normal-bg": "oklch(var(--popover))",
			"--normal-text": "oklch(var(--popover-foreground))",
			"--normal-border": "oklch(var(--border))",
			"--border-radius": "var(--radius-md)"
		},
		...props
	});
};
export { Toaster$1 as Toaster };

//# sourceMappingURL=toaster.js.map